import 'bootstrap/dist/css/bootstrap.min.css';
import Tabs from './Components/Tabs';

function App() {

    return <Tabs></Tabs>;
}

export default App;